module.exports = __webpack_public_path__ + "static/media/car_6.29a9ab8c.svg";